import React from 'react'
import { Component } from 'react'
import './FAQs.css'

class FAQs extends Component {

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  componentDidMount() {
    document.title = "FAQs - Out of Last Place Mississippi"
  }

  render() {
    return (
      <div>
        <section className="pages-hero faqs-hero">
          <h4>Frequently Asked Questions</h4>
        </section>

        <section id="faqs-section" className="content-section faqs-section">

            <div className="faqs-content">

              <div className="qa">

                <p><span>NOTE:</span> The “Bottom 7” in these FAQ’s refers to the other bottom 7 states as measured by per capita personal income, excluding Mississippi. These seven states are West Virginia, New Mexico, Idaho, Alabama, Arkansas, South Carolina, and Kentucky. We opted to use “Bottom 7” rather than a different measure because comparing Mississippi to these other 7 lowest income states includes neighboring states like Alabama and Arkansas, and several other states who have similar histories and demographics to Mississippi. Also, the income gap between Mississippi and West Virginia has varied somewhat over recent years from $3.9B in 2013 to $4.8B in 2014 to $6B in 2015 to $4.3B in preliminary calculations for 2016. For the purposes of this website, we have used the average of the last four (4) years which is $4.8B. The target of $4.8B was also the exact number for 2014, which were the latest numbers available in 2015 when the Out of Last Place project began and when some of our initial research papers (excerpted below) were released. </p>

              </div>

              <hr />

              <h6 className="numbering">1</h6>

              <div className="qa">

                <p><span>Question:</span> What is the best single measure of the economic prosperity and well-being of a state's residents? </p>

                <p><span>Answer: </span> “Per Capita Income”. Specifically: “Per Capita Personal Income” (PCPI) as measured by the Bureau of Economic Analysis (BEA). </p>

      	      </div>

               <hr />

               <h6 className="numbering">2</h6>

               <div className="qa">

                 <p><span>Question: </span> How does the economic prosperity and well-being of Mississippi's residents compare to that of other states? </p>

                 <p> <span>Answer: </span> Mississippi is currently in last place, with a per capita personal income that is lower than any other state, including the District of Columbia. </p>

      	        </div>

                <hr />

                <h6 className="numbering">3</h6>

                <div className="qa">

                  <p><span>Question: </span> How much does the per capita income of each Mississippian need to increase in order for Mississippi to move out of last place? </p>

                  <p><span>Answer: </span> Mississippi generated roughly $107 Billion in personal income in 2016 and had a population of nearly three million (2,988,726). Mississippi’s per capita personal income (PCPI) was $35,936, well below the national average of $49,571. Currently, 49th-ranked West Virginia’s per capita personal income is $37,386. Our per capita personal income would need to increase by $1,450 (almost exactly 4%) for every man, woman, and child in Mississippi ($5,800 annually for a family of four) in order to move out of last place in the rankings.</p>

                  <ul>
                    <li>Source:  <a href="https://www.bea.gov/itable/drilldown.cfm?reqid=70&stepnum=40&MajorAreaKey=3&GeoStateKey=0&GeoFipsReis=XX&TableIdReal=21&LineKey=3&YearReis=2016&YearReisBegin=-1&YearReisEnd=-1&UnitOfMeasureKeyReis=Levels&RankKeyReis=1&Drill=1&nRange=5" target="_blank">Bureau of Economic Analysis</a> </li>
                  </ul>

                 </div>

                 <hr />

                 <h6 className="numbering">4</h6>

                <div className="qa">

                  <p><span>Question: </span> Where has Mississippi historically ranked in per capita personal income since recordkeeping started in 1929? </p>

                  <p><span>Answer: </span> Unfortunately, Mississippi has ranked last every year since 1929, which was the year that recordkeeping began. Mississippi has generally been converging on the national average since 1929, but its growth relative to the average has slowed and leveled out in recent years with a gap of 4% to 49th, 21% to the Southeast average, and 38% to the U.S. average.</p>

                  <ul>
                    <li>	Source: <a href="https://www.bea.gov/itable/drilldown.cfm?reqid=70&stepnum=40&MajorAreaKey=3&GeoStateKey=0&GeoFipsReis=XX&TableIdReal=21&LineKey=3&YearReis=2016&YearReisBegin=-1&YearReisEnd=-1&UnitOfMeasureKeyReis=levels&RankKeyReis=1&Drill=1&nRange=5" target="_blank">Bureau of Economic Analysis</a></li>
                  </ul>

                </div>

                <hr />

                <h6 className="numbering">5</h6>

                <div className="qa">

                  <p><span>Question: </span> How many typical Mississippi jobs would our state's economy need to add in order for the income of those jobs to get Mississippi out of last place? </p>

                  <p><span>Answer: </span> To achieve the status of 49th, Mississippi would need 82,347 new jobs and total personal income would need to increase by $4.8 Billion (almost exactly 4%). To put this in perspective, consider that 76,500 people in Mississippi were counted as unemployed in May of 2016. Thus, Mississippi would need to employ all the unemployed and attract other individuals that are currently out of the labor force to work. Clearly, getting out of last place will require new jobs for those not working as well as higher incomes for those who are currently employed.</p>

                  <ul>
                	   <li>NOTE: It is important not to confuse supply with demand. Just because a new firm hires employees and opens for business doesn't automatically result in an increase in employment in the economy. There must first be an increase in demand for the goods or services provided by the firm. Without an increase in demand, the new firm is just competing for existing market share and the employees at the new firm merely replace the employees lost by the firms that lost market share. The estimates on this website for each scenario are based on the assumption that demand is driving the employment gains.</li>
                   </ul>

                </div>

                <hr />

                <h6 className="numbering">6</h6>

                <div className="qa">

                  <p><span>Question: </span> Does the number of jobs required to get Mississippi out of last place account for the loss in welfare payments, unemployment benefits, food stamps, and other federal transfer payments that would be lost when those individuals start going to work? </p>

                  <p><span>Answer: </span> No. Once the loss of those sources of income is accounted for, the actual number of typical Mississippi jobs required to close the gap to 49th is a good bit higher.</p>

              	</div>

                <hr />

                <h6 className="numbering">7</h6>

                <div className="qa">

                  <p><span>Question: </span> Are there enough Mississippians not working to fill that many jobs even if that many jobs did exist? </p>

                  <p><span>Answer: </span> Yes. Mississippi’s “Labor Force Participation Rate” is quite low as compared to other states. Most Mississippians that are not in the labor force are not counted as “unemployed” as they are not actively looking for work.</p>

                  <ul>
                    <li>	The total population in Mississippi in 2014 was 2,992,767. Of that number, 2,323,962 were 16 years old or older. Only 58.2% of those individuals (1,352,546) were “in the labor force”. That leaves 971,416 individuals that were 16 years old or older and not in the labor force. When you subtract the 131,141 individuals that were 65 years old or older, that leaves you with 840,275 individuals that were 16 to 64 years old and not in the labor force.</li>
                    <li>	If you assume that 85% of the very large number of individuals that were disabled in Mississippi were truly unable to work, that subtracts 229,648 individuals from the 840,275, leaving 610,627 individuals that were 16 to 64, not disabled, and not in the labor force.</li>
                    <li>	Making further adjustments to account for those in school, and those that were stay-at-home dads or moms, and further adjusting for those that were not likely to ever work, you still arrive at as many as 250,000 Mississippians that were 16 to 64 years old, able-bodied, not in school, not caring for children or loved ones, and also not in the labor force. Central to all efforts to get Mississippi out of last place is to find a way to bring these individuals into the workforce.</li>
                  </ul>

               </div>

               <hr />

               <h6 className="numbering">8</h6>

               <div className="qa">

                 <p><span>Question: </span> Who isn’t making the $4.8B of missing income? Is the problem that our low-income households are much lower income than other states, or is the problem that our high-income households are lower income than other states, or is it that our middle-income households are lower income than other states? </p>

                 <p><span>Answer: </span> It is important to understand that income quintiles are only available on a household basis. It is not possible to calculate quintiles on a “per capita” basis as the income of an income earner is shared by all those in a household, and thus household statistics are the only statistics available for this analysis. In order for Mississippi’s income to match the average of our “surrounding states” and other “Bottom” states, our bottom quintile of income would need to increase by 21.7%, our second lowest quintile would need to increase by 15.7%, our middle quintile would need to increase by 12.3%, our second highest quintile would need to increase by 9.4%, and our highest quintile of income would need to increase by 13.3%. In summary, our low-income households have a larger gap between them and other states than our other quintiles of income, but all income quintiles have a gap of at least 9.4%. It is important to note that although the gaps are larger at low incomes, on an absolute dollar basis most of the income is missing in higher income quintiles. This is because so much more income is earned in the higher income quintiles than in the lower income quintiles, and so even though the gaps are smaller, the absolute dollars that those gaps account for is much larger. For example, although the lowest income quintile in Mississippi is 21.7% lower than the comparison states, that only accounts for 5.1% of the missing dollars (because the gap accounts for relatively few absolute dollars). Although the highest income quintile in Mississippi is only 13.3% lower than the comparison states, that accounts for 52.8% of the missing dollars (because the gap accounts for a large number of dollars).</p>

               </div>

              <hr />

              <h6 className="numbering">9</h6>

              <div className="qa">

                <p><span>Question: </span> How many open job opportunities are there in Mississippi that remain unfilled? </p>

                <p><span>Answer: </span> The Mississippi Works initiative captures a daily snapshot of jobs available throughout the state based on the data maintained by MSU’s NSPARC. As of July 13, 2017, the number of open jobs was 35,893.</p>

                <ul>
                  <li>	Source: <a href="http://www.mississippiworks.org" target="_blank">www.mississippiworks.org</a> </li>
                </ul>

             </div>

             <hr />

             <h6 className="numbering">10</h6>

             <div className="qa">

               <p><span>Question: </span> Are there other measures of per capita income? </p>

               <p><span>Answer: </span> Yes. The Census Bureau publishes Per Capita “Money” Income (PCMI), but Per Capita Personal Income (PCPI) as measured by the BEA is more accurate and more complete, since it relies on administrative records rather than survey data, and PCPI (but not PCMI) is comprehensive in its measurement of income. The BEA's measure also has the advantage of complete records at the state level since 1929, while Census money income arising from the ACS (American Community Survey) has only been recorded annually since 2008. Such detailed statistics as are available for BEA's Per Capita Personal Income (PCPI) over a long timeframe are not readily available for other economic measures. To understand all the differences between PCPI and PCMI, please see Appendix A of the report titled “Per Capita Personal Income in Mississippi” for a comprehensive overview.</p>

    	      </div>

            <hr />

            <h6 className="numbering">11</h6>

            <div className="qa">

              <p><span>Question: </span> Does Mississippi's ranking improve when looking at Per Capita Money Income versus Per Capita Personal Income? </p>

              <p><span>Answer: </span> According to the “money income” measure, Mississippi is even worse off: 7.6% behind 49th (Arkansas) in Per Capita Money Income vs. 4% behind 49th (West Virginia) in Per Capita Personal Income. Such difference has to do with the fact that Per Capita Money Income does not include federal government transfer payments (welfare, food stamps, Medicaid, etc.), and Mississippi is a significant recipient of federal government transfer payments. A typical Mississippian in 2015 was more dependent on transfer receipts and received less compensation and asset income than a typical U.S. resident. Net earnings per capita were $20,401 in Mississippi and $30,729 in the nation. Dividends, interest, and rent per capita were $5,235 in Mississippi and $8,541 in the nation. Personal transfer receipts per capita were $8,806 in Mississippi and $7,932 in the nation.</p>

    	     </div>

           <hr />

           <h6 className="numbering">12</h6>

           <div className="qa">

             <p><span>Question: </span> I see “Median Household Income” quoted in the media a lot. Is that a good measure? </p>

             <p><span>Answer: </span> Median Household Income is not nearly as useful of a measure as Per Capita Income because the size of an average household changes significantly (1) over time, (2) between geographies, (3) between races, (4) by age of population, and is influenced by numerous other factors. For example, as the prosperity of a state or country increases, many households that were comprised of multiple families will split apart with each family becoming their own household. When that happens, what was counted as two or three families composing a single “household” and “household income” becomes counted as two or three separate households. What would appear to be a stagnation or decline in median household income could actually reflect prosperity driving an increased number of single-family dwellings. For example, let’s assume there is a single household comprised of two families with a total of ten people living under one roof with total income of $60,000. That is $60,000 in household income, and per-capita income of $6,000. Let’s assume due to improved economic conditions that the wage-earners in the household are able to increase their income to a total of $80,000 and therefore each of the two families decides they can now afford their own home. The single “household” and single “household income” is now divided by two. The truth is that everyone is better off and the change was driven by economic prosperity, but the “median household income” now is $40,000 instead of $60,000 because the $80,000 in new and higher income is divided by two, whereas the $60,000 in income was only counted as a single household. A decline from $60,000 to $40,000 in median household income may look bad, but the truth is that everyone is better off and the per-capita income increased from $6,000 to $8,000. That is one of the many reasons we use per capita income measures for all of our analyses rather than “household” or “family” income.</p>

      	    </div>

            <hr />

            <h6 className="numbering">13</h6>

            <div className="qa">

              <p><span>Question: </span> Are social security payments included in Per Capita Personal Income statistics? </p>

              <p><span>Answer: </span> Yes. All government transfer payments are included in measures of per capita personal income. This includes social security and other social welfare programs that result in a transfer of income to an individual.</p>

    	     </div>

           <hr />

           <h6 className="numbering">14</h6>

           <div className="qa">

             <p><span>Question: </span> Does Per Capita Personal Income include corporate income? </p>

             <p><span>Answer: </span> No. Corporate income is not counted in per capita income statistics. Per capita income is generally considered a better definition of individual well-being since it measures the income received by individuals. Most of corporate income is generated by purchases from individuals, so including that measure could “double count” some of this income. Ultimately, corporate profits that are transferred to individuals are counted in the income statistics.</p>

    	    </div>

          <hr />

          <h6 className="numbering">15</h6>

          <div className="qa">

            <p><span>Question: </span> I’ve heard that Mississippi has a lower Cost of Living than other states. How does Mississippi’s ranking change if the numbers are adjusted for Cost of Living? </p>

            <p><span>Answer: </span> When adjusted for cost of living (specifically cost of housing), Mississippi only climbs one spot in the rankings to 49th. While our per capita income is quite low, our cost of living (specifically housing) is even lower. That means a person receiving average per capita income in Mississippi has more purchasing power and a higher standard of living (due to low housing costs) than an average individual living in New Mexico. New Mexico has higher per capita income than Mississippi, but higher cost of living (specifically housing), and thus less purchasing power than Mississippi.</p>

            <ul>
              <li>The purchasing power of Mississippians in urban areas ranks 45th in the nation. This is due primarily to the fact that urban housing in Mississippi is only 73.5% of the national average. Some states have urban housing costs that are 160% to 170% of the national average. In short, more than double the costs in Mississippi.</li>
              <li>The purchasing power of Mississippians in rural areas ranks 40th in the nation. This is due primarily to the fact that rural housing in Mississippi is only 52.4% of the national average. Some states have rural housing costs that are 110% to 120% of the national average. In short, more than double the costs in Mississippi.</li>
            	<li>Research shows that housing is driving the difference in cost of living between states, since the cost of goods and services vary much less than the cost of housing.</li>
            </ul>

          </div>

          <hr />

          <h6 className="numbering">16</h6>

          <div className="qa">

            <p><span>Question: </span> So, to summarize, we know that the only reason Mississippi ranks ahead of New Mexico is because they have a higher cost of housing, and thus your money goes farther in Mississippi, and thus Mississippi ranks ahead of New Mexico in “cost-of-living-adjusted” per capita income. Isn’t that still a good thing, and shouldn’t more people want to live in Mississippi to take advantage of our low cost of living and low cost of housing specifically? </p>

            <p><span>Answer: </span> Low cost of living is certainly an asset, but unfortunately it doesn’t appear to be enough of a draw to entice a significant number of people to want to live in Mississippi without more jobs, economic activity, and higher incomes accompanying it. Population trends tell a pretty sobering story:</p>

            <ul>
              <li>	Mississippi’s population has only grown 5% since the year 2000, and is flat to slightly declining since 2013.</li>
              <li>	The population of the United States has grown 14% since the year 2000, and continues to grow.</li>
              <li>	The population of the Southeast has grown 18% since the year 2000, and continues to grow.</li>
              <li>	Since the year 2000, the population of the five states that are closes to Mississippi by this measure (New Mexico is behind Mississippi while the other four are ahead) have grown at the following rates: Hawaii (18%), Idaho (27%), Arizona (32%), New Mexico (15%), Utah (34%), and Mississippi (5%).</li>
            </ul>

          </div>

          <hr />

          <h6 className="numbering">17</h6>

          <div className="qa">

            <p><span>Question: </span> I’ve heard people say that Mississippi is the “poorest state in the nation”. Is that true? </p>

            <p><span>Answer: </span> It depends on how you define “poor”. If you define “poor” as average income per person statewide, then the answer would be yes. If you define poor as just the percentage of people living below the poverty level, then Mississippi ranks 48th with a poverty rate of 19.1%, ahead of Kentucky at 19.5% and New Mexico at 19.7%. If you look just at those individuals living below 50% of the poverty level (the “very poor”), then Mississippi ranks 45th at 8.3%, ahead of South Carolina at 8.4%, Kentucky at 8.6%, Georgia at 8.8%, Louisiana at 9.2%, and New Mexico at 10.2%. On this measure, Mississippi is also ahead of D.C., which has 8.9% of its population living below 50% of the poverty level.</p>

            <ul>
              <li>	Source:  <a href="https://www.census.gov/data/tables/time-series/demo/income-poverty/cps-pov/pov-46.html" target="_blank">The Census Bureau, POV46: Poverty Status by State: 2015</a> </li>
            </ul>

          </div>

          <hr />

          <h6 className="numbering">18</h6>

          <div className="qa">

            <p><span>Question: </span> How would getting out of last place on per capita income impact our poverty level? </p>

            <p><span>Answer: </span> Increasing Mississippi’s per capita income by $1,450 per person would lift individuals above the poverty level if they or their family were not too far below the poverty level. For most households with earnings of at least 75% of the poverty level, an additional $1,450 per person pushes them over the poverty threshold. Using some rough estimates, it would be safe to say that increasing Mississippi's per capita income by $1,450 would decrease the poverty rate in Mississippi to a level that is meaningfully less than 20 percent. That would rank Mississippi 45th or better on rankings for percentage of individuals living in poverty. </p>

    	   </div>

         <hr />

         <h6 className="numbering">19</h6>

         <div className="qa">

           <p><span>Question: </span> How does Mississippi’s income inequality compare to other states? </p>

           <p><span>Answer: </span> Using a measure known as the “Gini Coefficient,” Mississippi's inequality is measured as 47th in the nation. Since this measure only accounts for the distribution of income, it is not a precise picture of “inequality” per se. However, the variance between states on this metric is very small, and Mississippi is not substantially different than most other states in this regard. Please contact us if you would like additional detail on this answer as the detailed answer is quite technical. </p>

      	</div>

        <hr />

        <h6 className="numbering">20</h6>

        <div className="qa">

          <p><span>Question: </span> Other than for some of the rankings above, is Mississippi last in other rankings? </p>

          <p><span>Answer: </span> Mississippi ranks last in a number of measures. Also, in many of the rankings where we are not last, the ranking is of an “input measure” versus a “outcome measure”. For example, it doesn't do any good to be ranked number one as the sports team that “practices for the most hours” (an input measure) unless somehow down the line that translates into “wins the most games” (an outcome measure). By the same token, being ranked as a “great place to do business” or a “great place to be an entrepreneur” only matters if ultimately businesses and entrepreneurs start and thrive in our state. Otherwise, we are just a great environment for an activity that isn't happening (or isn't happening enough). </p>

      	</div>

        <hr />

        <h6 className="numbering">21</h6>

        <div className="qa">

          <p><span>Question: </span> Is the problem that not enough Mississippians are working? Or is the problem that working Mississippians aren’t making enough money? </p>

          <p><span>Answer: </span> Both. Mississippi’s Labor force participation rate (a measure of how many people are working or looking for work) is lower than our neighboring states by 2.9% and lower than the “Bottom 7” by 2.2%. This means that a smaller proportion of Mississippians are in the labor market, leading to fewer Mississippians working. Yet, even those Mississippians who are working are not making as much as workers in other states. The average annual pay of a Mississippi worker is 15% lower than workers in our neighboring states (averaged) and 10% lower than workers in a “Bottom 7” state (averaged). So, Mississippians are also making less money.   </p>

      	</div>

        <hr />

        <h6 className="numbering">22</h6>

        <div className="qa">

          <p><span>Question: </span> Is the problem that not enough Mississippians are working? Or is the problem that those Mississippians that are working are not making enough money? If it is both problems, what % of the problem is “not enough working” and what % of the problem is “those working not making enough”? </p>

          <p><span>Answer: </span> The problem is both. XY% of the problem is “not enough working” and XY% of the problem is “those working not making enough.” </p>

          <ul>
            <li>	Note: We are still working to determine the exact percentages for these two numbers. Check back soon!</li>
          </ul>

        </div>

        <hr />

        <h6 className="numbering">23</h6>

        <div className="qa">

          <p><span>Question: </span> For the “not making enough” part of the question above, are those individuals not making enough because they are working part time? </p>

          <p><span>Answer: </span> This information is especially difficult to get. What we do know so far is this: The unemployment “U-6 rate” adds workers who are employed part time for economic reasons to the U-5 rate. As an example, workers may be employed part time for economic reasons when a full-time job is not available to the worker due to a recession. Four percentage points of Mississippi's total U-6 rate is the result of such part time workers. Mississippi has a higher proportion than neighboring states of such workers but is similar to the nation in this respect. All of the further details we do know are covered in the report titled “Labor and Employment in Mississippi”. </p>

      	</div>

        <hr />

        <h6 className="numbering">24</h6>

        <div className="qa">

          <p><span>Question: </span> For the “not making enough” part of the question above, are those individuals not making enough because they aren’t working enough hours? Or are they “not making enough” because they get paid less per hour? </p>

          <p><span>Answer: </span> Interestingly enough, Mississippians who are employed work 1.6% more hours than workers in the “Bottom 7” states and 0.4% more hours than workers in our neighboring states. The issue is not the number of hours Mississippians work. Mississippians on average make $5.34 less per hour than workers in “Bottom 7” states and $7.69 less per hour than workers in our neighboring states. Therefore, fewer Mississippians are working (see immediately prior questions) and those that are working, while putting in more hours, are paid less per hour than equivalent workers in similar states. All of the further details we know are covered in the report titled “Labor and Employment in Mississippi.” </p>

      	</div>

        <hr />

        <h6 className="numbering">25</h6>

        <div className="qa">

          <p><span>Question: </span> What are “Blueprint States”? </p>

          <p><span>Answer: </span> Blueprint States are Mississippi's neighboring states (Alabama, Louisiana, Arkansas, and Tennessee) plus Texas, Oklahoma, North Carolina, South Carolina, Kentucky, Georgia, and Florida. These were the states chosen by the State of Mississippi as a logical comparison group because these are the states that economic development professionals in Mississippi regard as our most closely aligned competitors. While national comparisons are interesting from an intellectual point of view, it is more important to note how our state compares to the market in which we compete vs. the nation as a whole. </p>

      	</div>

        <hr />

        <h6 className="numbering">26</h6>

        <div className="qa">

          <p><span>Question: </span> What is the definition of (1) Labor Force, (2) Civilian Non-Institutional Population, and (3) Unemployed? </p>

          <p><span>Answer: </span> </p>

          <ul>
            <li>Labor Force – All persons in the civilian non-institutional population characterized as either employed or unemployed.</li>
            <li>Civilian Non-Institutional Population – Includes persons 16 years of age and older, who are not inmates of institutions (e.g., penal and mental facilities, homes for the aged), and who are not on active duty in the Armed Forces.</li>
            <li>Unemployed – People are characterized as unemployed if they do not have a job, have actively looked for work in the prior 4 weeks, and are currently available for work.</li>
            <li>See the report titled “Labor and Employment in Mississippi” for detailed descriptions and calculations. It is important to note from these definitions that people who are capable of working will not be counted as part of the labor force if they are not working and are not actively seeking employment. These individuals are technically out of the labor force even if they would like to have a job.</li>
          </ul>

        </div>

        <hr />

        <h6 className="numbering">27</h6>

        <div className="qa">

          <p><span>Question: </span> How have national Labor Force Participation Rates (LFPR) changed over time? </p>

          <p><span>Answer: </span> There was an upward trend in LFPRs through the nineties that was driven by rapidly rising female LFPRs which dominated declining male LFPRs. Explanations for rising female LFPRs include rising real wages for women (which encouraged women to work more), changing preferences and attitudes toward women in the work place, improved household technology that decreased the amount of time necessary for household work, declining birth rates, and rising divorce rates. Some researchers have attributed the decline in LFPRs from 2000 to 2013 to increased retirement and disability and a significant increase in the number of discouraged workers, or workers who would like to have a job but who do not actively seek one and, as such, are not counted among labor force participants.  </p>

      	</div>

        <hr />

        <h6 className="numbering">28</h6>

        <div className="qa">

          <p><span>Question: </span> How has Mississippi's Labor Force Participation Rates (LFPR) changed over time? </p>

          <p><span>Answer: </span> Mississippi's LFPR has remained below the nation's LFPR over this entire time period. In fact, Mississippi's LFPR has diverged even further from the nation’s LFPR in recent years. Since 2005, Mississippi has persistently trailed neighboring states with the exception of pulling ahead of Alabama in 2011 and 2012. Moreover, Mississippi's LFPR is lower today than it was in 1976. </p>

      	</div>

        <hr />

        <h6 className="numbering">29</h6>

        <div className="qa">

          <p><span>Question: </span> How does Mississippi's Labor Force Participation Rate (LFPR) compare to other states? </p>

          <p><span>Answer: </span> The LFPRs of Mississippians are lower than those in the comparison states. </p>

      	</div>

        <hr />

        <h6 className="numbering">30</h6>

        <div className="qa">

          <p><span>Question: </span> What is the reason for Mississippi's lower Labor Force Participation Rate (LFPR) as compared to other states? </p>

          <p><span>Answer: </span> According to research by the W.E. Upjohn Institute, there are five primary factors: </p>

          <ol>
           <li> The relatively high concentration of Mississippi residents in Non-Metropolitan areas is the most consistent reason for Mississippi's lower LFPR.</li>
           <li> Mississippi's relatively high percentage of African-American residents has a mixed impact on its LFPR. For men and younger persons, it tends to reduce the LFPR. For married women, it raises the LFPR because the LFPR of African-American married women exceeds that of white married women.</li>
           <li>	Higher incidence of health problems also helps explain the lower LFPR of Mississippi.</li>
           <li>	Higher incidence of government transfer receipt helps explain the lower LFPR of Mississippi.</li>
           <li>	Lower educational attainment reduces the LFPR of Mississippi.</li>
         </ol>

         <p>According to the authors, these five measurable differences (percent in a Non-Metropolitan area, percent African American, percent with health problems, percent with government transfers, and lower educational levels) are capable of explaining “most” of the gap in LFPRs between Mississippians and individuals living in Blueprint States for all but younger persons that are ages 16 to 24. “For younger persons, more than half of the gap must be attributed to cultural, historical, and institutional factors that are difficult to measure and quantify.” </p>

      	</div>

        <hr />

        <h6 className="numbering">31</h6>

        <div className="qa">

          <p><span>Question: </span> How does the education of Mississippians compare to other states? </p>

          <p><span>Answer: </span> Mississippi trails the nation and its neighboring states. This difference is important because LFPRs tend to increase as education levels rise. </p>

      	</div>

        <hr />

        <h6 className="numbering">32</h6>

        <div className="qa">

          <p><span>Question: </span> How does the percentage of Mississippians who are disabled compare to other states? </p>

          <p><span>Answer: </span> The percentage of individuals who are disabled is much higher in Mississippi and in the neighboring states than in the nation. Of the population under 65 years of age, 11.9% of Mississippians are disabled while only 8.5% of the nation is disabled. Arkansas experiences a slightly higher percentage at 12.2%. Additionally, a higher percentage of individuals younger than 54 receives Social Security Income in Mississippi relative to the comparison states. About 4.5% of men 25-54 in Mississippi receive income from Social Security (presumably mainly in the form of Disability Income), compared with 3.8% in neighboring states and 2.8% in the Blueprint States. These differences are substantial and suggest that the incidence of Social Security Disability receipt among prime-age males in Mississippi is 36% higher than in the neighboring states, and 60% higher than in the Blueprint States. The differences are significant in light of the importance of men 25-54 to the labor force. </p>

      	</div>

        <hr />

        <h6 className="numbering">33</h6>

        <div className="qa">

          <p><span>Question: </span> How does the percentage of Mississippians receiving Supplemental Security Income (SSI) compare to other states? </p>

          <p><span>Answer: </span> A higher percentage of Mississippians receive Supplemental Security Income than in surrounding states or Blueprint States. This holds for males and females and across all age categories examined. </p>

      	</div>

        <hr />

        <h6 className="numbering">34</h6>

        <div className="qa">

          <p><span>Question: </span> What are Social Security Disability Insurance (SSDI) and Supplemental Security Income (SSI)? </p>

          <p><span>Answer: </span> Social Security Disability Insurance program and the Supplemental Security Insurance program are both federally funded and run by the Social Security Administration. Social Security Disability is paid to disabled individuals who are insured, meaning that they worked for some period of time and paid Social Security taxes. The Supplemental Security Insurance program pays benefits based on financial need. See <a href="https://www.ssa.gov/disability" target="_blank">www.ssa.gov&#47;disability</a> for more details. </p>

      	</div>

        <hr />

        <h6 className="numbering">35</h6>

        <div className="qa">

          <p><span>Question: </span> Do government programs allow individuals who don't work to receive checks, providing incentives for people to live off of welfare in areas with no jobs? </p>

          <p><span>Answer: </span> While there are several government programs that provide transfer payments to low income citizens, the traditional idea of “welfare checks,” where individuals who are able to work receive checks to cover all of their living expenses, no longer exists and does not explain why Mississippi is in last place. The Temporary Assistance for Needy Families program, or TANF, provides cash assistance to families with children under 18 to help them meet basic needs. Mississippi&rsquo;s program has incorporated a work program that requires able-bodied parents to gain employment, volunteer, or participate in job training in order to receive assistance for their children. The other primary assistance programs are Medicaid and Social Security Disability payments, which are mandated and controlled by the federal government. In Mississippi, neither of these programs includes able-bodied adults. </p>

      	</div>

        <hr />

        <h6 className="numbering">36</h6>

        <div className="qa">

          <p><span>Question: </span> How does the percentage of Mississippians without health insurance compare to other states? </p>

          <p><span>Answer: </span> More Mississippians (16.8%) are without health insurance than are citizens in most neighboring states or in the nation (12.0%).  </p>

      	</div>

        <hr />

        <h6 className="numbering">37</h6>

        <div className="qa">

          <p><span>Question: </span> How does Mississippi’s racial composition compare to other states? </p>

          <p><span>Answer: </span> Mississippi's racial composition is quite different from that of the nation. Nationally, 13.2% of the population is African American. Mississippi's population is 37.5% African American, the highest of any state in the nation. Louisiana ranks second in the nation, with 32.5% of its population comprised of African Americans. This difference matters because African Americans have lower LFPRs than other demographics. Importantly, however, even if Mississippi's population statistics are adjusted to match the African-American populations of surrounding states, Mississippi still ranks 50th in per capita income. </p>

      	</div>

        <hr />

        <h6 className="numbering">38</h6>

        <div className="qa">

          <p><span>Question: </span> How does the percentage of Mississippians living in urban vs. rural areas compare to other states? </p>

          <p><span>Answer: </span> Less than one-half of Mississippi’s population lives in urban areas. At 45.6%, the percentage of people living in an urban area in Mississippi is strikingly lower than the percentage for the nation as a whole (85.5%) and ranks last among our neighboring states. This difference is important because residents of non-metropolitan areas have lower LFPRs than do residents of metropolitan areas. </p>

      	</div>

        <hr />

        <h6 className="numbering">39</h6>

        <div className="qa">

          <p><span>Question: </span> How does Mississippi's unemployment rate compare to other states? </p>

          <p><span>Answer: </span> Mississippi experiences higher rates of unemployment than the nation and its neighbors and it has the lowest per capita income in the nation. Over time, Mississippi experiences unemployment rates that are higher than the nation. Since 2010, Mississippi's unemployment rate has been declining but is higher than all neighboring states. </p>

      	</div>

        <hr />

        <h6 className="numbering">40</h6>

        <div className="qa">

          <p><span>Question: </span> How do Unemployment statistics change when looking at U3 vs. U4 vs. U5 vs. U6 unemployment and what are “Discouraged Worker” and “Marginally Attached” workers and how do they stack up as compared to other states? </p>

          <p><span>Answer: </span> This is too multi-faceted to explain in our FAQs. Please see our report titled “Labor and Employment in Mississippi” for all the details and explanations! </p>

      	</div>

        <hr />

        <h6 className="numbering">41</h6>

        <div className="qa">

          <p><span>Question: </span> What is the summary of all the Labor Force information above? </p>

          <p><span>Answer: </span> Mississippi has fewer individuals in the population who are of prime working age – ages 25 to 64. Mississippi has fewer individuals in the labor force than all neighboring states, including Arkansas, even though Mississippi has a larger population. Mississippi has a lower labor force participation rate than neighboring states. That is, among the population that is eligible to work, fewer are working or attempting to work in Mississippi than in neighboring states. Mississippi&rsquo;s lower overall labor force participation rate is driven by Mississippi’s demographic composition. Mississippi has a higher concentration of African Americans, disabled, and less educated individuals. Mississippi has more individuals living in non-urban areas as well. Each of these groups participates in the labor force at lower rates. For those participating in the labor force, Mississippians are unemployed at higher rates than in the nation and neighboring states. </p>

      	</div>

        <hr />

        <h6 className="numbering">42</h6>

        <div className="qa">

          <p><span>Question: </span> How have the various sectors of Mississippi's economy changed over time? </p>

          <p><span>Answer: </span> In Mississippi, there has been a dramatic drop in manufacturing employment since the mid-nineties. This drop has been somewhat but not completely offset by an increase in jobs in the leisure and hospitality industry after casinos were legalized in the state. Since 1990, Mississippi has experienced its highest level of growth in the leisure and hospitality, education and health services, and professional and business services industries. Note that the government sector has grown 20% since 1990 and it has been Mississippi’s largest employer since early 2000. </p>

      	</div>

        <hr />

        <h6 className="numbering">43</h6>

        <div className="qa">

          <p><span>Question: </span> How does Mississippi's employment compare to our surrounding states? </p>

          <p><span>Answer: </span> Per 1,000 people employed, Mississippi has 218 working in government, more than any of the neighboring states. Mississippi has the lowest number of individuals working in professional and business services, financial activities, and other services. </p>

    	 </div>

       <hr />

       <h6 className="numbering">44</h6>

       <div className="qa">

         <p><span>Question: </span> What if our LFPR was more like our neighbors and all those additional participants had “typical” Mississippi jobs? </p>

         <p><span>Answer: </span> If Mississippi's LFPR was on par with the average LFPR of its neighboring states, Mississippi's LFPR would increase 2.94%. This would add 67,088 individuals to the labor force. Assuming that the unemployment rate and average Mississippi wage stayed constant, then 62,790 of these new entrants to the labor market would find work and increase Mississippi’s income by $2.36 billion, closing 49.24% of the income gap between Mississippi and West Virginia.  </p>

         <ol>
           <li>	Note: The assumption of a constant unemployment rate and average wage would only hold constant if there was commensurate growth in total number of jobs available.</li>
         </ol>

      	</div>

        <hr />

        <h6 className="numbering">45</h6>

        <div className="qa">

          <p><span>Question: </span> What if our LFPR was more like the “Bottom 7” states and all those additional participants had “typical” Mississippi jobs? </p>

          <p><span>Answer: </span> If Mississippi's LFPR was on par with the average LFPR of other “Bottom 7” states, Mississippi's LFPR would increase 2.23%. This would add 50,779 individuals to the labor force. Assuming that the unemployment rate and average Mississippi wage stayed constant then 47,526 of these new entrants to the labor market would find work and increase Mississippi’s income by $1.79 billion, closing 37.27% of the income gap between Mississippi and West Virginia.  </p>

    	 </div>

       <hr />

       <h6 className="numbering">46</h6>

       <div className="qa">

          <p><span>Question: </span> What if Mississippi's unemployment rate was more like the surrounding states and all those additional people had typical Mississippi jobs? </p>

          <p><span>Answer: </span> If Mississippi's unemployment rate was on par with the average unemployment rate in our surrounding states, Mississippi's unemployment rate would decrease from 6.4% to 5.8%. When applied to Mississippi's labor force in 2015, this 0.6 percentage point decrease in Mississippi's unemployment rate would mean that an additional 8,000 Mississippians would be employed. If these individuals were employed at the current average wage they would increase Mississippi’s income by $301.1 million, closing 6.27% of the income gap between Mississippi and West Virginia. </p>

    	 </div>

       <hr />

       <h6 className="numbering">47</h6>

       <div className="qa">

         <p><span>Question: </span> What if Mississippi's unemployment rate was more like other “Bottom 7” states and all those additional people had typical Mississippi jobs? </p>

         <p><span>Answer: </span> If Mississippi's unemployment rate was on par with the average unemployment rate in other “Bottom 7” states, Mississippi's unemployment rate would decrease from 6.4% to 5.7%. When applied to Mississippi's labor force in 2015, this 0.7 percentage point decrease in Mississippi's unemployment rate would mean that an additional 8,784 Mississippians would be employed. If these individuals were employed at the current average wage they would increase Mississippi’s income by $330.7 million, closing 6.89% of the income gap between Mississippi and West Virginia. </p>

      	</div>

        <hr />

        <h6 className="numbering">48</h6>

        <div className="qa">

          <p><span>Question: </span> I've heard that the reason that Mississippi is last is because of “the Delta”. Is that true? </p>

          <p><span>Answer: </span> No. The 15 counties that compose “the Delta” are poorer on average than the state as a whole, but the Delta county's Per Capita Personal Income (PCPI) is only 10.2% lower than the rest of the state. Additionally, only 10.6% of Mississippi's population lives in the Delta. For those two reasons, regardless of whether Mississippi's per capita income is calculated with or without the Delta, Mississippi still ranks 50th. In fact, taking the Delta out of the equation only closes 22% of the gap between Mississippi and 49th. That still leaves 78% of the gap that must be solved by increasing income in all the non-Delta counties. To indicate how widespread low-income is in Mississippi, consider that only 6 counties in Mississippi have per capita income that is higher than West Virginia. That means that 76 counties, if they were states, would each individually rank 50th in per capita income. Incomes must be raised statewide to lift Mississippi out of last place. Raising incomes in the Delta to the state average will only get Mississippi 22% of the way to 49th. </p>

          <ul>

            <li>NOTE: Even if it was true that removing the Delta from Mississippi changed the rankings, in order to get a fair comparison between Mississippi and other states, you would have to remove the poorest region of each of the other 49 states before making a comparison. Every state has a region that is poorer, on average, than the rest of each given state.</li>
          </ul>

        </div>

        <hr />

        <h6 className="numbering">49</h6>

      <div className="qa">

          <p><span>Question: </span> Is the reason that taking the Delta out of Mississippi doesn't change the rankings because the Delta is such a large recipient of “transfer payments?” Do these transfer payments decrease the gap in income between the Delta and other parts of the state? </p>

          <p><span>Answer: </span> If you take transfer payments out of the picture, Mississippi is still last overall. With transfer payments included, the Delta is 9.5% poorer than the non-Delta regions of the state. With transfer payments excluded, the Delta is 23.3% poorer than the non-Delta regions of the state. In either case, with only 10.6% of the total Mississippi population living in the Delta, that income gap isn&rsquo;t large enough to cause Mississippi to move out of last place regardless of whether it is measured with or without transfer payments. </p>

      	</div>

        <hr />

        <h6 className="numbering">50</h6>

        <div className="qa">

          <p><span>Question: </span> If the state's rankings aren’t skewed by the Delta, how widespread is the problem of low income? </p>

          <p><span>Answer: </span> Setting aside the 15 counties that compose the Delta, there are 67 remaining counties in Mississippi. 48 of these 67 counties have a lower average income than the 15 Delta counties. The problem of low income is widespread in Mississippi, and its effects are also manifested statewide. </p>

      	</div>

        <hr />

        <h6 className="numbering">51</h6>

        <div className="qa">

          <p><span>Question: </span> Where do the six counties that do not rank 50th rank in comparison to the other states? </p>

          <p><span>Answer: </span> Madison would rank 5th between New York and Alaska. Rankin would rank 34th between Maine and Missouri. Hinds would rank 45th between Idaho and South Carolina. Lee and Jones would rank 49th between New Mexico and West Virginia. All other counties (76 of the 82) would rank 50th if they were individual states. </p>

      	</div>

        <hr />

        <h6 className="numbering">52</h6>

        <div className="qa">

          <p><span>Question: </span> With that many counties ranking 50th in the rankings if they were states, what percent of legislators represent a county that would rank 50th if it were a state? </p>

          <p><span>Answer: </span> About 85% of state legislators in the Mississippi House and the Mississippi Senate represent all or part of one of the 76 counties that has a lower per capita income than West Virginia, and thus would rank 50th if it were a state.  </p>

      	</div>

        <hr />

        <h6 className="numbering">53</h6>

        <div className="qa">

          <p><span>Question: </span> Does the placement of Mississippi's borders affect our ranking? </p>

          <p><span>Answer: </span> Yes. If the boundary lines of Mississippi had been drawn such that Mississippi had a major city the size of Memphis or New Orleans within its boundary lines, Mississippi would not be ranked 50th. Consider the following: </p>

          <ul>
            <li>If Mississippi’s northern border was just 25 to 30 miles farther north, Mississippi would jump to 49th in the rankings. The reason is that Shelby County, Tennessee (the single county that encompasses Memphis) would be one of a total of four and a half counties that would be part of Mississippi vs. Tennessee. If that were the case, Mississippi would jump to 49th and Tennessee would fall two spots from 36th to 38th in the rankings. Mississippi’s northern border was arbitrarily chosen to be along the same horizontal line as Georgia’s northern border (with the same is true of Alabama), as Georgia’s northern border already existed at the time the northern borders of Mississippi and Alabama were chosen.</li>
            <li>If Shelby County by itself (the single county that encompasses Memphis, but not the poorer counties east of Shelby County) was a Mississippi county vs. a Tennessee county, Mississippi would immediately jump three spots to 47th in per capita income. Just having that one county on the Mississippi side of the state line adds nearly a million people and nearly $42B in income, which is a huge uplift. Tennessee would only drop in the rankings from 36th to 37th if it lost just Shelby County.</li>
            <li>If Orleans Parish and St. Tammany Parish (the two counties that encompass most of New Orleans) were in Mississippi vs. in Louisiana, Mississippi would also immediately jump three spots to 47th in per capita income. Just having those two counties on the Mississippi side of the state line adds over 600,000 people and nearly $30B in income, all from just two counties. Louisiana would only drop in the rankings from 30th to 32nd if it lost Orleans Parish and St. Tammany Parish.</li>
            <li>If the ten (10) parishes that are east of the Mississippi River (which encompasses New Orleans and Baton Rouge) were in Mississippi vs. in Louisiana, Mississippi would immediately jump six spots to 44th in per capita income rather than 50th. Having those ten counties on the Mississippi side of the state line adds over 1,500,000 people and nearly $70B in income, all from counties that are on the Mississippi side (east side) of the Mississippi River, but on the Louisiana side of the state line. Louisiana would only drop in the rankings from 30th to 32nd if it lost the ten (10) parishes that are east of the Mississippi River.</li>
            <li>	NOTE: It requires a major city to change the rankings. If Mobile, Alabama was in Mississippi, that would not be enough to change the rankings. If Mississippi was able to duplicate the tri-county area (Madison, Ranking, and Hinds) somewhere else in the state, that would also not be enough by itself to change the rankings. Likewise, having Baton Rouge in Mississippi by itself (without New Orleans) is not enough to change the rankings. A major city like Memphis or New Orleans is the only thing related to boundary lines that changes the rankings.</li>
          </ul>

      	</div>

        <hr />

        <h6 className="numbering">54</h6>

        <div className="qa">

          <p><span>Question: </span> Why was the land between the Mississippi River and the Pearl River given to Louisiana rather than Mississippi when the land was annexed from Spain in 1810? </p>

          <p><span>Answer: </span> In 1810, the land above that line in Mississippi and Alabama was known as the “Mississippi Territory”. “West Florida” was the strip of land underneath what is now most of Mississippi and Alabama (everything below the horizontal line at the southern border of southwest Mississippi and southeast Alabama). “West Florida” was under Spanish control and located below the Mississippi Territory, stretching from the Mississippi River all the way to Florida. The first piece of “West Florida” to be annexed (1810) was the part between the Mississippi River and the Pearl River. This piece of land was especially valuable as it included the east bank of the mouth of the Mississippi River (including the cities of New Orleans and Baton Rouge). With the Louisiana Purchase (1803) the United States secured the west bank of the Mississippi River, and sought to gain control of the eastern bank, which was located in “West Florida” and under Spanish control. The United States needed a justification for annexing the land between the Mississippi River and the Pearl River from the Spanish, and the best justification they could come up with was that they believed that that land had been understood to be part of the Louisiana Purchase (from France). Given that justification, it only made sense to annex that land to Louisiana rather than to the Mississippi Territory as that reinforced the justification for the annexation. Had that portion of land been given to the Mississippi Territory, it would have become part of Mississippi when the Mississippi Territory was divided in 1816 into the two states Mississippi and Alabama. In addition to reinforcing the justification for annexation, there were many cultural ties between that portion of land and the land that was purchased in the Louisiana Purchase as both pieces of land had been held by the French at various points in history and were adjacent to each other on opposite sides at the mouth of the Mississippi River. </p>

      	</div>

        <hr />

        <h6 className="numbering">55</h6>

        <div className="qa">

          <p><span>Question: </span> Does Mississippi’s mix of urban vs. rural population impact our rankings? </p>

          <p><span>Answer: </span> Yes. It does make a difference. Consider the following:</p>

          <ul>
            <li>Mississippi is one of the most rural states in the nation with 54.4% of our population living outside of urban areas. Only three other states are more rural than Mississippi. Those three states are: Montana (64.4% rural), Vermont (65.5% rural), and Wyoming (69.5% rural). That means that Mississippi has a higher percentage of our population living in rural areas than even states such as Alaska, New Mexico, Idaho, West Virginia, Arkansas, Kentucky, North Dakota, and South Dakota.</li>
            <li>If every state was like Mississippi and had 54.4% of their residents living in rural areas and 45.6% living in urban areas, then Mississippi would no longer be last, but would rank 48th ahead of South Carolina (49th) and Arizona (50th). The reason is that both Arizona and South Carolina have per capita incomes of their rural population that is lower than the per capita income of Mississippi's rural population. The reason they don’t rank last overall is because they have more people living in urban areas. In Arizona only 5% of the people live in rural areas and in South Carolina only 15% of the people live in rural areas. If those two low-income populations (the rural populations) were both much larger (as they are in Mississippi at 54.4%), that would result in South Carolina and Arizona ranking behind Mississippi.</li>
            <li>Overall the per capita income of Mississippi's urban residents ranks 49th, ahead of Idaho.</li>
            <li>Overall the per capita income of Mississippi's rural residents ranks 44th, ahead of Arkansas, Kentucky, Florida, South Carolina, Georgia, and Arizona (ranked 45th through 50th respectively). Mississippi&rsquo;s rural residents rank behind West Virginia, North Carolina, Alabama, and Tennessee (ranked 40th through 43rd respectively).</li>
          </ul>

        </div>

        <hr />

        <h6 className="numbering">56</h6>

        <div className="qa">

          <p><span>Question: </span> I have heard about a principle called the multiplier effect. What is it and how does it affect your estimates of the effect of different options for closing the income gap? </p>

          <p><span>Answer: </span> The “multiplier effect” refers to the way in which the end result of money being injected into an economic system is often greater than the original amount injected. This has to do with how money circulates between actors in an economy and how that affects the accounting of measures like income and GDP. For example, when you receive extra income you spend a portion of it, that money spent becomes extra income for someone else who in turn spends a portion of it, and the cycle continues. Given that we are measuring a cash flow, income – the increase you experienced – ends up being measured several times as other people’s income also increases when you spend a portion of your new income. Therefore, the final increase in total income of all participants is greater than the increase of your income alone. However, measuring this effect is difficult as there are active debates on just how strong it is, and it can be the source of much confusion and contention. Therefore, we have elected to not include the multiplier effect in our calculations. As such, some of our estimates may under estimate the effect of various actions on increasing PCPI.</p>

        </div>

        <hr />

        <h6 className="numbering">57</h6>

        <div className="qa">

          <p><span>Question: </span> What needs to happen in order to move Mississippi out of last place and enable Mississippi to climb in the per capita personal income rankings? </p>

          <p><span>Answer: </span> That is the $4.8 Billion question! And that is what this website and our research is dedicated to finding. Stay tuned! </p>

          <p>NOTE: The income gap between Mississippi and West Virginia has varied somewhat over recent years from $3.9B in 2013 to $4.8B in 2014 to $6B in 2015 to $4.3B in preliminary calculations for 2016. For the purposes of this website, we have used the average of the last four (4) years which is $4.8B. The target of $4.8B was also the exact number for 2014, which were the latest numbers available in 2015 when the Out of Last Place project began and when some of our initial research papers (excerpted above) were released. </p>

        </div>

        <hr />

      </div>

      </section>

    </div>

    )
  }

}



export default FAQs;



/** WEBPACK FOOTER **
 ** ./src/components/pages/FAQs.js
 **/